(function() {
    'use strict';

    angular
        .module('atheer.core')
        .run(layoutRunner)
        .provider('triLayout', layoutProvider);

    /* @ngInject */
    function layoutProvider() {
        var layoutDefaults = {
            toolbarSize: 'default',
            toolbarShrink: true,
            toolbarClass: '',
            contentClass: '',
            innerContentClass: '',
            sideMenuSize: 'full',
            showSideNavMenu: false,
            sideNavMenuSize: 15,
            showToolbar: true,
            footer: true,
            contentLayoutTemplateUrl: 'core/layouts/default-content.tmpl.html',
            contentLayoutController: 'DefaultLayoutController',
            sidebarLeftTemplateUrl: 'core/components/leftsidenav/leftsidenav.tmpl.html',
            sidebarLeftController: 'MenuController',
            sidebarNotificationsTemplateUrl: 'core/components/notifications/notifications.tmpl.html',
            sidebarNotificationsController: 'NotificationsSideNavController',
            toolbarTemplateUrl: 'core/components/toolbars/toolbar.tmpl.html',
            toolbarController: 'DefaultToolbarController',
            footerTemplateUrl: 'core/components/footer/footer.tmpl.html'
        };
        var resetableOptions = [
          'toolbarSize', 'toolbarShrink', 'toolbarClass', 'contentClass',
          'innerContentClass', 'sideMenuSize', 'showToolbar', 'showSideNavMenu', 'sideNavMenuPosition', 'sideNavMenuSize', 'footer',
          'contentLayoutTemplateUrl', 'contentLayoutController',
          'sidebarLeftTemplateUrl', 'sidebarLeftController',
          'sidebarNotificationsTemplateUrl', 'sidebarNotificationsController',
          'toolbarTemplateUrl', 'toolbarController',
          'tabMenuTemplateUrl',
          'tabMenuController', 'footerTemplateUrl', 'loaderTemplateUrl', 'loaderController'];
        var layout = {};

        this.getDefaultOption = getDefaultOption;
        this.setDefaultOption = setDefaultOption;

        function getDefaultOption(name) {
            return layoutDefaults[name];
        }

        function setDefaultOption(name, value) {
            layoutDefaults[name] = value;
        }

        // init

        angular.extend(layout, layoutDefaults);

        // Service
        this.$get = function() {
            function setOption(name, value) {
                layout[name] = value;
            }

            function updateLayoutFromState(event, toState) {
                // reset classes
                angular.forEach(resetableOptions, function(option){
                    layout[option] = layoutDefaults[option];
                });
                var layoutOverrides = angular.isDefined(toState.data) && angular.isDefined(toState.data.layout) ? toState.data.layout : {};
                angular.extend(layout, layout, layoutOverrides);
            }

            return {
                layout: layout,
                setOption: setOption,
                updateLayoutFromState: updateLayoutFromState
            };
        };
    }

    /* @ngInject */
    function layoutRunner($rootScope, triLayout) {
        // check for $stateChangeStart and update the layouts if we have data.layout set
        // if nothing set reset to defaults for every state
        var destroyOn = $rootScope.$on('$stateChangeStart', triLayout.updateLayoutFromState);
        $rootScope.$on('$destroy', removeWatch);

        /////////////

        function removeWatch() {
            destroyOn();
        }
    }
})();
